import { freedomApp } from 'freedom-shared';

import { sentryModel } from '@/shared/model';

/**
 * Helper function to send amplitude events via JS Bridge
 */
export const sendEvent = (eventName: string, params?: object) => {
  freedomApp.lib.sendAmplitudeEvent(
    {
      name: eventName,
      product: 'Freedom Travel : Avia',
      toSA: false,
      params: params || {},
    },
    (error: Error) =>
      sentryModel.captureException(
        sentryModel.getReadableError('ERR_SEND_JS_BRIDGE_EVENT', error),
      ),
  );
};
